import React, { useContext, useState } from "react";
import "./ConfirmPopup.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import DeleteIcon from "@mui/icons-material/Delete";
import CommercialContext from "../context/CommercialContext";
import { useEffect } from "react";
import ThreeDot from "../loading/Three dots/Three_dot";

const ConfirmPopup = ({ message, id, deleteFunction, isLoading }) => {
  const { task } = useContext(CommercialContext);
  const [modalShow, setModalShow] = useState(false);
  const handleClose = () => setModalShow(false);
  const handleShow = () => setModalShow(true);

  useEffect(() => {
    handleClose();
  }, [task]);
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "25px 2px",
        }}
      >
        <Button variant="danger" onClick={handleShow}>
          <DeleteIcon />
        </Button>
      </div>

      <Modal
        show={modalShow}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>{message}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
         <Button type="submit" variant="danger" onClick={() => deleteFunction(id)} className="btn" disabled={isLoading}>
                        {!isLoading ? "Delete" : <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "2px" }}>en cours <ThreeDot /></div>}
                     </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ConfirmPopup;
